import React from 'react';
import { WeezHeader, Status, Icon, EmptyState } from '@weezevent/nacre';
import { useDateFormat } from '../../../hooks';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Loading } from '../../../components';
import { EntityOverview } from './components/EntityOverview';
import { LegalEntities } from './components/LegalEntities';
import { BankAccounts } from './components/BankAccounts';
import { StoreProvider, useStore } from './store';
import { PayoutProfiles } from './components/PayoutProfiles';
import classes from './Overview.module.scss';

const Content = () => {
    const { t } = useTranslation();

    const {
        financeEntity: { data, isLoading }
    } = useStore();

    const { properDate } = useDateFormat({
        date: data?.created_at
    });

    const renderTitle = () => {
        return (
            <div className={classes.title}>
                {data?.name}
                <Status responsive color="green">
                    {t('common.active')}
                </Status>
            </div>
        );
    };

    const getSubtitle = () => {
        return `${t('common.created')} : ${properDate}`;
    };

    if (isLoading) {
        return <Loading active />;
    }

    if (!data) {
        return <EmptyState title={t('sauron.financeModule.fullyEmpty.title')} icon={<Icon margin name="traffic-barrier" size="regular" />} />;
    }

    return (
        <>
            <WeezHeader title={renderTitle()} isFixed>
                <div className={classes.subtitle}>{getSubtitle()}</div>
            </WeezHeader>
            <EntityOverview />
            <LegalEntities />
            <BankAccounts />
            <PayoutProfiles />
        </>
    );
};

export const FinanceEntitiesOverview = ({ organizationId }) => {
    return (
        <StoreProvider organizationId={organizationId}>
            <Content />
        </StoreProvider>
    );
};

FinanceEntitiesOverview.propTypes = {
    organizationId: PropTypes.string.isRequired
};
